// Centralized API library
// All API calls should go through this module

// Domain-specific APIs
export * from './auth'
export * from './canvases'
export * from './cases'
export type { RequestOptions } from './client'
export { ApiError, apiClient } from './client'
export * from './entity-resolution'
export * from './extensions'
export * from './geolocation'
// Export from graph and notes separately to avoid conflicts
export type {
  CreateNoteRequest as GraphCreateNoteRequest,
  GraphFindingItem,
  GraphNoteItem,
  GraphNoteOrFinding,
  NotesAndFindingsResponse,
  UpdateNoteRequest as GraphUpdateNoteRequest,
} from './graph'
export * from './identities'
export type { CaseNote, CreateNoteRequest, UpdateNoteRequest } from './notes'
export * from './pdf'
export * from './saved-queries'
export * from './schemaSessions'
export * from './schemas'
export * from './timeline'

// Re-export for convenience
import { authApi } from './auth'
import { canvasesApi } from './canvases'
import { casesApi } from './cases'
import { entityResolutionApi } from './entity-resolution'
import { extensionsApi } from './extensions'
import { geolocationApi } from './geolocation'
import { graphApi } from './graph'
import { identitiesApi } from './identities'
import { notesApi } from './notes'
import { pdfApi } from './pdf'
import { savedQueriesApi } from './saved-queries'
import { schemaSessionsApi } from './schemaSessions'
import { schemasApi } from './schemas'
import { timelineApi } from './timeline'

export const api = {
  auth: authApi,
  cases: casesApi,
  graph: graphApi,
  identities: identitiesApi,
  savedQueries: savedQueriesApi,
  entityResolution: entityResolutionApi,
  schemas: schemasApi,
  schemaSessions: schemaSessionsApi,
  canvases: canvasesApi,
  notes: notesApi,
  extensions: extensionsApi,
  geolocation: geolocationApi,
  timeline: timelineApi,
  pdf: pdfApi,
}

// Usage examples:
// import { api } from '@/services/api'
//
// const cases = await api.cases.list()
// const graph = await api.graph.getGraph(caseId)
// const identities = await api.identities.list(caseId)
